// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Eritrea */
const ER = /^(?:(?:17[1-3]|7\d\d)\d{4})$/;

export default ER;
